import { Component, OnInit, Input } from "@angular/core";
import { TopNavBtn } from "../../classes/navbar";

@Component({
  selector: "top-nav-btns",
  templateUrl: "./top-nav-btns.component.html",
  styleUrls: ["./top-nav-btns.component.scss"],
})
export class TopNavBtnsComponent implements OnInit {
  @Input() topNavBtns: Array<TopNavBtn>;
  @Input() isAdmin: boolean;
  @Input() isRestrictedUser: boolean;
  @Input() hasDataWall: boolean;
  @Input() currentPage: string;
  @Input() rgpTenantId: string;

  constructor() {}

  ngOnInit() {}

  canShowBtn(btnDetails: TopNavBtn) {
    return (
      (btnDetails.isAdminRestricted ? this.isAdmin : true) &&
      (btnDetails.hideFromRestrictedUser ? !this.isRestrictedUser : true) &&
      (btnDetails.needsDataWallSub ? this.hasDataWall : true)
    );
  }

  checkIfBolded(btnDetails: TopNavBtn) {
    if (btnDetails.title == "Mosaic" && this.currentPage) {
      return (
        this.currentPage.includes("comparison") ||
        this.currentPage.includes("profile") ||
        this.currentPage.includes("usage") ||
        this.currentPage == "/"
      );
    } else if (btnDetails.title == "Settings" && this.currentPage) {
      return this.currentPage.includes("settings");
    }
    return false;
  }
}
